import { TRootState } from '../../common/reducers';
import {
  selectArticle,
  selectCategories,
  selectCategoryArticles,
  selectCurrentCategory,
} from '../../common/selectors/helpCenter';
import { selectHomepageContent, selectRecommendedArticles } from '../../common/selectors/homepage';
import { selectSolutions } from '../../common/selectors/solutions';
import { Page } from '../../common/types';
import {
  createArticleSolutionInfo,
  createCategoriesSolutionInfo,
  createHomepageSolutionInfo,
  createSearchResultsSolutionInfo,
  createSolutionListSolutionInfo,
} from '../solutionInfo';
import { SolutionInfo } from '../types';

export const solutionInfoPageMapper: Record<
  Page,
  (state: TRootState) => SolutionInfo | SolutionInfo[] | undefined
> = {
  [Page.Article]: (state) => {
    const article = selectArticle(state);
    return article ? createArticleSolutionInfo({ articleId: article?.id }) : undefined;
  },
  [Page.Categories]: (state) => {
    const categories = selectCategories(state);
    return categories ? createCategoriesSolutionInfo(categories, false) : undefined;
  },
  [Page.Category]: (state) => {
    const category = selectCurrentCategory(state);
    const categoryArticles = selectCategoryArticles(state);

    if (!category) {
      return;
    }

    if (category.children?.length) {
      return createCategoriesSolutionInfo(category.children, true);
    } else {
      return createSolutionListSolutionInfo(categoryArticles);
    }
  },
  [Page.Search]: (state) => {
    const solutions = selectSolutions(state);
    return createSearchResultsSolutionInfo(solutions || []);
  },
  [Page.Home]: (state) => {
    const content = selectHomepageContent(state);
    const recommendedArticles = selectRecommendedArticles(state);
    return createHomepageSolutionInfo(content.data, recommendedArticles.data?.articles);
  },
  [Page.Chatbot]: () => undefined,
};
